<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 2; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn">
      <div class="cf-header">
        <img
          @click="$router.go(-1), clearForm()"
          class="mr-3 pointer"
          src="../../assets/customfield/blueBackArrow.svg"
          alt=""
        />
        {{ formName }}
      </div>
      <div class="ct-main-container">
        <div class="ct-left-container mt-2">
          <div class="ct-table-top">
            <div class="ct-table-head-txt pl-2">
              {{
                formName && formName.endsWith("Form")
                  ? formName + " Fields"
                  : formName + " Form Fields"
              }}
            </div>
            <div
              v-if="roles.includes('PUT_FORM')"
              @click="setFieldValues(), $bvModal.show('previewcandidateform')"
            >
              <img
                class="pointer"
                src="../../assets/customfield/blueEye.svg"
                alt=""
              />
            </div>
          </div>
          <div class="ct-table-container">
            <div class="ct-table-head mt-4 mb-2">
              <div class="w-4"></div>
              <div
                class="d-flex align-items-center w-96 ct-right-head-back mr-2"
              >
                <div class="w-25 pl-3">Field Name</div>
                <div class="w-20">Type</div>
                <div class="w-15">Required</div>
                <div class="w-20">Limit</div>
                <div class="w-10"></div>
                <div class="w-10"></div>
              </div>
            </div>

            <div class="ct-table-body pr-2">
              <template v-for="i in getFixedFields">
                <div v-if="!i.hide" :key="i.label" class="ct-table-row mb-2">
                  <div class="w-4"></div>
                  <div
                    class="d-flex align-items-center w-96 ct-right-table-back"
                  >
                    <div class="ct-table-bold-txt w-25 pl-3">{{ i.label }}</div>
                    <div class="ct-table-bold-txt-2 w-20">
                      {{ capitalize(i.controlType) }}
                    </div>
                    <div class="w-15 ct-table-switch-mandatory">
                      <b-form-checkbox
                        disabled
                        v-model="i.mandatory"
                        switch
                      ></b-form-checkbox>
                    </div>
                    <div class="ct-table-bold-txt-2 w-20">
                      {{
                        i.controlType === "upload_file" && i.maxFileSize
                          ? i.maxFileSize + " MB"
                          : i.limit
                          ? i.limit + " Char"
                          : "-"
                      }}
                    </div>
                    <div class="w-10 ct-pretxt"></div>
                    <div class="w-10"></div>
                  </div>
                </div>
              </template>
              <hr
                class="mt-0 mb-0"
                :class="
                  currentForm.categories &&
                  currentForm.categories.length == 0 &&
                  'mb-2'
                "
              />
              <div
                class="pl-4 ml-4 mt-2 mb-1"
                v-if="
                  currentForm.categories && currentForm.categories.length != 0
                "
              >
                <span class="ct-table-bold-txt-3">Basic Fields -</span>
                <span class="cf-light-txt">
                  Customized fields to fit your hiring procedure.</span
                >
              </div>
              <div
                v-if="
                  currentForm.categories &&
                  currentForm.categories.length != 0 &&
                  basics.length == 0
                "
                class="ct-table-row mb-2"
              >
                <div class="w-4">
                  <!-- <img src="../../assets/customfield/dragndrop.svg" alt="" /> -->
                </div>
                <div class="d-flex align-items-center w-96 ct-right-table-back">
                  <div class="cf-light-txt w-100 text-center">
                    No Fields has been added in basic fields
                  </div>
                </div>
              </div>

              <draggable
                v-if="
                  currentForm.categories && currentForm.categories.length != 0
                "
                v-model="basics"
                group="lists"
                @end="onDragEnd"
              >
                <template v-for="i in basics">
                  <div v-if="!i.hide" :key="i.label" class="ct-table-row mb-2">
                    <div class="w-4 pointer">
                      <img
                        src="../../assets/customfield/dragndrop.svg"
                        alt=""
                      />
                    </div>
                    <div
                      class="d-flex align-items-center w-96 ct-right-table-back"
                      :style="
                        editField &&
                        editData.key == i.key &&
                        'background-color : #E1EEF7 !important;'
                      "
                    >
                      <div class="ct-table-bold-txt w-25 pl-3">
                        {{ i.label }}
                      </div>
                      <div class="ct-table-bold-txt-2 w-20">
                        {{ capitalize(i.controlType) }}
                      </div>
                      <div class="w-15 ct-table-switch">
                        <b-form-checkbox
                          v-model="i.mandatory"
                          disabled
                          switch
                        ></b-form-checkbox>
                      </div>
                      <div class="ct-table-bold-txt-2 w-20">
                        {{
                          i.controlType === "upload_file" && i.maxFileSize
                            ? i.maxFileSize + " MB"
                            : i.limit
                            ? i.limit + " Char"
                            : "-"
                        }}
                      </div>
                      <div class="w-10 ct-pretxt">
                        {{
                          i.fieldType == "predefinedField"
                            ? "PREDEFINED"
                            : "CUSTOM"
                        }}
                      </div>
                      <div
                        v-if="roles.includes('PUT_FORM')"
                        class="w-10 d-flex align-items-center"
                      >
                        <img
                          v-if="editField && editData.key == i.key"
                          class="mr-2 disable-inputField"
                          src="../../assets/customfield/disableblueedit.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="setEditData(i)"
                          class="mr-2 pointer"
                          src="../../assets/customfield/blueEdit.svg"
                          alt=""
                        />
                        <img
                          v-if="editField && editData.key == i.key"
                          class="mr-2 disable-inputField"
                          height="25"
                          width="25"
                          src="../../assets/customfield/disableddelete.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="removeData(i.key)"
                          class="pointer"
                          src="../../assets/customfield/blueDelete.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </draggable>

              <div
                class="pl-4 ml-4 mt-2 mb-1"
                v-if="
                  currentForm.categories && currentForm.categories.length != 0
                "
              >
                <span class="ct-table-bold-txt-3">Advanced Fields -</span>
                <span class="cf-light-txt">
                  Tailored to fit the specific needs of your hiring
                  procedure.</span
                >
              </div>
              <div
                v-if="
                  currentForm.categories &&
                  currentForm.categories.length != 0 &&
                  advanced.length == 0
                "
                class="ct-table-row mb-2"
              >
                <div class="w-4">
                  <!-- <img src="../../assets/customfield/dragndrop.svg" alt="" /> -->
                </div>
                <div class="d-flex align-items-center w-96 ct-right-table-back">
                  <div class="cf-light-txt w-100 text-center">
                    No Fields has been added in advance fields
                  </div>
                </div>
              </div>

              <draggable
                v-if="
                  currentForm.categories && currentForm.categories.length != 0
                "
                v-model="advanced"
                group="lists"
                @end="onDragEnd"
              >
                <template v-for="i in advanced">
                  <div v-if="!i.hide" :key="i.label" class="ct-table-row mb-2">
                    <div class="w-4 pointer">
                      <img
                        src="../../assets/customfield/dragndrop.svg"
                        alt=""
                      />
                    </div>
                    <div
                      class="d-flex align-items-center w-96 ct-right-table-back"
                      :style="
                        editField &&
                        editData.key == i.key &&
                        'background-color : #E1EEF7 !important;'
                      "
                    >
                      <div class="ct-table-bold-txt w-25 pl-3">
                        {{ i.label }}
                      </div>
                      <div class="ct-table-bold-txt-2 w-20">
                        {{ capitalize(i.controlType) }}
                      </div>
                      <div class="w-15 ct-table-switch">
                        <b-form-checkbox
                          v-model="i.mandatory"
                          disabled
                          switch
                        ></b-form-checkbox>
                      </div>
                      <div class="ct-table-bold-txt-2 w-20">
                        {{
                          i.controlType === "upload_file" && i.maxFileSize
                            ? i.maxFileSize + " MB"
                            : i.limit
                            ? i.limit + " Char"
                            : "-"
                        }}
                      </div>
                      <div class="w-10 ct-pretxt">
                        {{
                          i.fieldType == "predefinedField"
                            ? "PREDEFINED"
                            : "CUSTOM"
                        }}
                      </div>
                      <div
                        v-if="roles.includes('PUT_FORM')"
                        class="w-10 d-flex align-items-center"
                      >
                        <img
                          v-if="editField && editData.key == i.key"
                          class="mr-2 disable-inputField"
                          src="../../assets/customfield/disableblueedit.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="setEditData(i)"
                          class="mr-2 pointer"
                          src="../../assets/customfield/blueEdit.svg"
                          alt=""
                        />
                        <img
                          v-if="editField && editData.key == i.key"
                          class="mr-2 disable-inputField"
                          height="25"
                          width="25"
                          src="../../assets/customfield/disableddelete.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="removeData(i.key)"
                          class="pointer"
                          src="../../assets/customfield/blueDelete.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </draggable>

              <draggable
                v-if="
                  currentForm.categories && currentForm.categories.length == 0
                "
                v-model="fields"
                group="lists"
                @end="onDragEnd"
              >
                <template v-for="i in fields">
                  <div v-if="!i.hide" :key="i.label" class="ct-table-row mb-2">
                    <div class="w-4 pointer">
                      <img
                        src="../../assets/customfield/dragndrop.svg"
                        alt=""
                      />
                    </div>
                    <div
                      class="d-flex align-items-center w-96 ct-right-table-back"
                      :style="
                        editField &&
                        editData.key == i.key &&
                        'background-color : #E1EEF7 !important;'
                      "
                    >
                      <div class="ct-table-bold-txt w-25 pl-3">
                        {{ i.label }}
                      </div>
                      <div class="ct-table-bold-txt-2 w-20">
                        {{ capitalize(i.controlType) }}
                      </div>
                      <div class="w-15 ct-table-switch">
                        <b-form-checkbox
                          v-model="i.mandatory"
                          disabled
                          switch
                        ></b-form-checkbox>
                      </div>
                      <div class="ct-table-bold-txt-2 w-20">
                        {{
                          i.controlType === "upload_file" && i.maxFileSize
                            ? i.maxFileSize + " MB"
                            : i.limit
                            ? i.limit + " Char"
                            : "-"
                        }}
                      </div>
                      <div class="w-10 ct-pretxt">
                        {{
                          i.fieldType == "predefinedField"
                            ? "PREDEFINED"
                            : "CUSTOM"
                        }}
                      </div>
                      <div
                        v-if="roles.includes('PUT_FORM')"
                        class="w-10 d-flex align-items-center"
                      >
                        <img
                          v-if="editField && editData.key == i.key"
                          class="mr-2 disable-inputField"
                          src="../../assets/customfield/disableblueedit.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="setEditData(i)"
                          class="mr-2 pointer"
                          src="../../assets/customfield/blueEdit.svg"
                          alt=""
                        />
                        <img
                          v-if="editField && editData.key == i.key"
                          class="mr-2 disable-inputField"
                          height="25"
                          width="25"
                          src="../../assets/customfield/disableddelete.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="removeData(i.key)"
                          class="pointer"
                          src="../../assets/customfield/blueDelete.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
          <div
            class="
              d-flex
              align-items-center
              justify-content-end
              border-top
              mt-2
              pt-2
              pr-4
              bluebtn
            "
          >
            <b-button
              v-if="roles.includes('PUT_FORM')"
              :disabled="checkDiscard"
              @click="$bvModal.show('discardModal')"
              class="acs-cancelBtn-modal mr-3 mt-1"
              >Discard</b-button
            >
            <b-button
              class="acs-addBtn-modal mt-1 pointer"
              v-if="roles.includes('PUT_FORM')"
              @click="saveFields()"
              >Save Fields</b-button
            >
          </div>
        </div>
        <customsearch
          :allFields="
            getFixedFields.concat(fields).concat(basics).concat(advanced)
          "
          :predefinedFields="filterObjectsByKeys"
          :editField="editField"
          :editData="editData"
          :discard="discard"
          @changeEdit="changeValue"
          @addToFields="addFieldData"
          @afterdiscard="changeDiscard"
        />
      </div>
    </div>
    <b-modal id="discardModal" centered hide-footer hide-header @hidden="$bvModal.hide('discardModal')">
      <div class="d-flex">
        <div class="mr-3">
          <img
            v-b-popover.hover.top="'Close'"
            src="../../assets/customfield/yellowDiscard.svg"
            alt=""
          />
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between">
            <div class="acs-modal-head">Discard Changes</div>
            <div @click="$bvModal.hide('discardModal')">
              <img
                class="rotate-on-hover"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt=""
              />
            </div>
          </div>
          <div class="acs-modal-content pr-3 mt-1">
            Are you sure you want to discard the data you entered ?
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4">
        <b-button
          class="acs-cancelBtn-modal mr-3"
          @click="$bvModal.hide('discardModal')"
          >Cancel</b-button
        >
        <b-button
          class="acs-addBtn-modal"
          @click="(discard = true), clearForm(), $bvModal.hide('discardModal')"
          >Discard</b-button
        >
      </div>
    </b-modal>
    <b-modal
      id="previewcandidateform"
      size="lg"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="$bvModal.hide('previewcandidateform'),
                    (showBasics = true),
                    (roundModalSvg = true)"
    >
      <div id="previewmodal" class="d-flex">
        <div class="cs-left-modal-back"></div>
        <div class="w-94">
          <div class="cs-modal-header">
            <div>
              Preview
              {{
                formName && formName.endsWith("Form")
                  ? formName
                  : formName + " Form"
              }}
            </div>
            <div>
              <img
                @click="
                  $bvModal.hide('previewcandidateform'),
                    (showBasics = true),
                    (roundModalSvg = true)
                "
                class="rotate-on-hover pointer"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt=""
              />
            </div>
          </div>
          <div v-if="formName == 'Job Form'" class="d-flex w-100">
            <div class="tab-1">
              Basic Details
              <img
                class="tab-svg"
                src="../../assets/customfield/blueTabbBD.svg"
                alt=""
              />
            </div>
            <div class="tab-2 disablepointer">
              Interview Process
              <img
                class="tab-svg"
                src="../../assets/customfield/GreyInterP.svg"
                alt=""
              />
            </div>
            <div class="tab-2 disablepointer">
              Assign
              <img
                class="tab-svg"
                src="../../assets/customfield/greyAssign.svg"
                alt=""
              />
            </div>
          </div>
          <div class="mt-4 cs-modal-body">
            <customPreview :fieldData="fieldData" :data="getFixedFields" />
            <div
              v-if="basics.length != 0"
              class="d-flex align-items-center mt-3"
            >
              <div @click="showBasics = !showBasics" class="ml-3">
                <img
                  v-if="showBasics"
                  src="../../assets/customfield/modalTopArrow.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/customfield/modalDownArrow.svg"
                  alt=""
                />
              </div>
              <div class="cs-bluetxt ml-2 mr-3">Basics</div>
              <div class="modal-horizontal-line"></div>
            </div>
            <b-collapse v-model="showBasics">
              <customPreview :fieldData="fieldData" :data="basics" />
            </b-collapse>

            <div
              v-if="advanced.length != 0"
              class="d-flex align-items-center mt-3"
            >
              <div @click="roundModalSvg = !roundModalSvg" class="ml-3">
                <img
                  v-if="roundModalSvg"
                  src="../../assets/customfield/modalTopArrow.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/customfield/modalDownArrow.svg"
                  alt=""
                />
              </div>
              <div class="cs-bluetxt ml-2 mr-3">Advanced</div>
              <div class="modal-horizontal-line"></div>
            </div>
            <b-collapse v-model="roundModalSvg">
              <customPreview :fieldData="fieldData" :data="advanced" />
            </b-collapse>
            <customPreview :fieldData="fieldData" :data="fields" />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import customPreview from "../../components/CustomSearch/customPreview.vue";
import customsearch from "../../components/CustomSearch/customsearch.vue";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import { getSingleForm, saveFields } from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import toast from "../../components/mixin/toast.js";

export default {
  name: "customtable",
  data() {
    return {
      discard: false,
      LoaderStatus: false,
      editField: false,
      editData: null,
      fields: [],
      basics: [],
      advanced: [],
      initialBasics: [],
      initialAdvanced: [],
      initialFieldData: [],
      selected: null,
      showBasics: true,
      roundModalSvg: true,
      predefinedDropdown: false,
      options: [
        { text: "Radio 1", value: "radio1" },
        { text: "Radio 3", value: "radio2" },
        { text: "Radio 3 (disabled)", value: "radio3" },
        { text: "Radio 4", value: "radio4" },
      ],
      fieldData: [],
      formName: null,
      currentForm: {},
    };
  },
  mixins: [toast],
  components: {
    customsearch,
    draggable,
    Spinner,
    customPreview,
  },
  computed: {
    ...mapGetters(["roles"]),
    getFixedFields() {
      return this.fieldData.filter((obj) => obj.fieldType == "default");
    },
    filterObjectsByKeys() {
      let value = this.fieldData.filter(
        (obj) => obj.fieldType == "predefinedField"
      );
      if (this.currentForm.predefinedFields) {
        return this.currentForm.predefinedFields.filter(
          (obj1) => !value.some((obj2) => obj2.key === obj1.key)
        );
      }
      return [];
    },
    checkDiscard() {
      this.setFieldData();
      if (
        this.initialFieldData.length !== this.fieldData.length ||
        this.initialBasics.length !== this.basics.length ||
        this.initialAdvanced.length !== this.advanced.length
      ) {
        return false;
      }
      for (let i = 0; i < this.initialFieldData.length; i++) {
        // Convert each object to JSON for comparison
        const obj1 = JSON.stringify(this.initialFieldData[i]);
        const obj2 = JSON.stringify(this.fieldData[i]);
        // Compare JSON strings
        if (obj1 !== obj2) {
          return false;
        }
      }
      return true;
    },
  },
  watch: {
    fields(value) {
      if (value && this.editField) {
        for (let i in this.fields) {
          if (this.editField && this.fields[i].key == this.editData.key) {
            this.editData.category = null;
            this.editData.seq = parseInt(i) + 1;
          }
        }
      }
    },
    basics(value) {
      if (value) {
        for (let i in this.basics) {
          this.basics[i].category = 1;
          this.basics[i].seq = parseInt(i) + 1;
          if (this.editField && this.basics[i].key == this.editData.key) {
            this.editData.category = 1;
            this.editData.seq = parseInt(i) + 1;
          }
        }
      }
    },
    advanced(value) {
      if (value) {
        for (let i in this.advanced) {
          this.advanced[i].category = 2;
          this.advanced[i].seq = parseInt(i) + 1;
          if (this.editField && this.advanced[i].key == this.editData.key) {
            this.editData.category = 2;
            this.editData.seq = parseInt(i) + 1;
          }
        }
      }
    },
  },
  methods: {
    setFieldData() {
      this.fieldData = this.getFixedFields
        .concat(this.fields)
        .concat(this.basics)
        .concat(this.advanced);
      this.initialBasics = this.initialFieldData.filter(
        (obj) => obj.fieldType != "default" && obj.category == 1
      );
    },
    setData() {
      this.basics = this.fieldData.filter(
        (obj) => obj.fieldType != "default" && obj.category == 1
      );
      this.advanced = this.fieldData.filter(
        (obj) => obj.fieldType != "default" && obj.category == 2
      );
      this.fields = this.fieldData.filter(
        (obj) => obj.category == null && obj.fieldType != "default"
      );
    },
    changeDiscard(value) {
      this.discard = value;
    },
    columnWidth(data) {
      if (
        data == "text" ||
        data == "email" ||
        data == "single_select" ||
        data == "multi_select" ||
        data == "number" ||
        data == "boolean"
      ) {
        return 4;
      } else if (data == "upload_file") {
        return 9;
      } else {
        return 12;
      }
    },
    setEditData(data) {
      this.editData = null;
      this.editData = { ...data };
      this.editField = true;
    },
    changeValue() {
      this.editField = false;
    },
    setFieldValues() {
      if (this.basics.length != 0) {
        for (let i in this.basics) {
          this.basics[i].category = 1;
          this.basics[i].seq = parseInt(i) + 1;
        }
      }
      if (this.advanced.length != 0) {
        for (let i in this.advanced) {
          this.advanced[i].category = 2;
          this.advanced[i].seq = parseInt(i) + 1;
        }
      }
      if (this.fields.length != 0) {
        for (let i in this.fields) {
          this.fields[i].category = null;
          this.fields[i].seq = parseInt(i) + 1;
        }
      }
    },
    saveFields() {
      this.setFieldValues();
      let newarr = this.getFixedFields
        .concat(this.fields)
        .concat(this.basics)
        .concat(this.advanced);
      let filteredData = newarr.filter((obj) => !obj.parentKey);
      let children = newarr.filter((obj) => obj.parentKey);
      for (let i in filteredData) {
        if (filteredData[i].fieldType != "default") {
          filteredData[i].seq = parseInt(i) + 1;
        }
      }
      for (let i in children) {
        let value = filteredData.find(
          (obj) => obj.key == children[i].parentKey
        );
        children[i].category = value.category;
        children[i].seq = value.seq;
      }
      let finalarr = filteredData.concat(children);
      finalarr.sort((a, b) => {
        if (a.seq < b.seq) {
          return -1;
        }
        if (a.seq > b.seq) {
          return 1;
        }
        return 0;
      });
      this.saveFieldData(finalarr);
    },
    async saveFieldData(fieldsData) {
      this.LoaderStatus = true;
      try {
        let payload = {
          parentID: this.$route.query.id,
          fields: fieldsData,
        };
        const res = await saveFields(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          this.successModal("Form saved successfully");
          this.$nextTick(() => {
            this.$router.push({
              path: "customform",
            });
          });
        } else {
          this.LoaderStatus = false;
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
      }
    },
    removeData(key) {
      this.fieldData = this.fieldData.filter(
        (obj) => obj.key != key && obj.parentKey != key
      );
      this.setData();
    },
    capitalize(text) {
      return text.replace(
        /(?:^|_)([a-z])/g,
        (match, char) => " " + char.toUpperCase()
      );
    },
    clearForm() {
      this.fieldData = [];
      this.getSingleFormData();
    },
    addFieldData(field) {
      let child = null;
      if (this.currentForm.categories.length != 0 && !this.editField) {
        field.category = 1;
        if (field.child) {
          field.child.category = 1;
        }
      }
      if (field.child) {
        field.child.parentKey = field.key;
        child = field.child;
        delete field.child;
      }
      if (!this.editField) {
        this.currentForm.categories.length != 0
          ? this.basics.push(field)
          : this.fields.push(field);
        if (
          this.formName === "Job Form" &&
          field.key === "experienceRequired" &&
          !this.fieldData.some((obj) => obj.key === "minExperienceRequired")
        ) {
          let otherField = {
            apiEndPoint: null,
            category: field.category,
            controlType: "text",
            dateTimeFormat: null,
            dropdown: false,
            fieldType: "customField",
            fileFormat: null,
            filter: true,
            hide: true,
            key: "minExperienceRequired",
            label: "Min Experience",
            parentKey: "experienceRequired",
            limit: 15,
            mandatory: false,
            maxFileSize: null,
            multi: false,
            placeholder: "Enter min experience",
            search: true,
            sort: true,
            sortType: 1,
            values: [],
          };
          this.currentForm.categories.length != 0
            ? this.basics.push(otherField)
            : this.fields.push(otherField);
        }
      }
      if (child && !this.editField) {
        this.addFieldData(child);
      }
      this.fieldData = this.getFixedFields
        .concat(this.fields)
        .concat(this.basics)
        .concat(this.advanced);
      if (this.editField) {
        let ind = this.fieldData.findIndex((obj) => {
          if (obj.key == field.key) {
            return true;
          }
        });
        this.fieldData.splice(ind, 1, field);
        this.setData();
        // this.fieldData = this.fieldData.filter((obj) => obj.key != field.key);
      }
      // this.setData();
      this.editData = null;
      this.editField = false;
    },
    async getSingleFormData() {
      this.LoaderStatus = true;
      try {
        let payload = {
          parentID: this.$route.query.id,
        };
        const res = await getSingleForm(payload);
        if (res.status == 200) {
          this.currentForm = res.data.data;
          this.formName =
            res.data.data.parentFormName.parentSubFormName ||
            res.data.data.parentFormName.parentFormName;
          this.fieldData = res.data.data.fields;
          this.initialFieldData = res.data.data.fields;
          this.setData();
          this.initialBasics = this.basics;
          this.initialAdvanced = this.advanced;
          this.LoaderStatus = false;
        } else {
          this.LoaderStatus = false;
        }
      } catch (error) {
        console.error(error);
        this.LoaderStatus = false;
      }
    },
  },
  created() {
    this.getSingleFormData();
  },
};
</script>

<style lang="postcss" scoped></style>
